import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { CardEditComponent } from 'src/common/components/card-edit/card-edit.component';
import { BackurlService } from 'src/common/services/backurl/backurl.service';
import { SettingService } from 'src/common/services/setting/setting.service';
import { MandateService } from 'src/services/mandate/mandate.service';

@Component({
  selector: 'app-organise-visit-edit',
  templateUrl: './organise-visit-edit.component.html',
  styleUrls: ['./organise-visit-edit.component.scss']
})
export class OrganiseVisitEditComponent extends CardEditComponent {

  constructor(
    protected _cd: ChangeDetectorRef,
    public setting: SettingService,
    public db: MandateService,
    protected router: Router,
    public backURL: BackurlService,
  ) {
    super(_cd, setting, db, router, backURL);
  }



}
